import React from "react";

const TermsContent = () => {
  return (
    <section className="py-16 bg-cloud-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              {/* Header */}
              <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-forest-green mb-4">
                  Cittasya® Terms and Conditions
                </h1>
                <div className="w-24 h-1 bg-gradient-to-r from-soft-saffron to-copper-brown mx-auto rounded-full"></div>
              </div>

              {/* 1. Overview */}
              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  1
                </span>
                Overview
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Cittasya Wellness (OPC) Private Limited (which are collectively
                referred to as the “Cittasya®” "Company", "we", "us" or "our")
                operates the Cittasya® Mobile App, the website www.cittasya.com,
                and its other digital platforms (collectively referred to as
                “Platform”). The headings used in this agreement are included
                for convenience only and will not limit or otherwise affect
                these Terms.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                The Company offers this Platform, including all “Information”,
                tools and Services available from this Platform to you, the
                user, conditioned upon your acceptance of all terms, conditions,
                policies and notices stated here. Information includes the text,
                audios, comments, posts, software, scripts, graphics, photos,
                sounds, music, videos, audiovisual combinations, interactive
                features and other materials you may view on, access through, or
                contribute to the Service. All Information available on the
                Platform, with the trademarks, Service marks and logos,
                excluding third party materials, are owned by or licensed to
                Cittasya®, subject to any intellectual property rights under the
                governing law.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                By visiting our Platform and/ or purchasing something from us,
                you engage in our “Service” and agree to be bound by the
                following terms and conditions (“Terms and Conditions”),
                including those additional terms and conditions and policies
                referenced herein and/or available by hyperlink. These Terms and
                Conditions apply to all users of the Platform, including,
                without limitation, users who are browsers, vendors, customers,
                merchants, and/ or contributors of content.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Please read these Terms and Conditions carefully before
                accessing or using our Platform. By accessing or using any part
                of the Platform, you agree to be bound by these Terms and
                Conditions. If you do not agree to all the terms and conditions
                of this agreement, then you shall not access the Platform or use
                any Services.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Any new features or tools which are added to the Platform shall
                also be subject to the Terms and Conditions.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  2
                </span>
                ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                In order to access features of the Service, you will have to
                create a Cittasya® Account. You shall only use your account, and
                never transfer your account or use any third-party account. When
                creating your account, you must provide accurate and complete
                information. You must notify Cittasya® immediately of any breach
                of security or unauthorized use of your account. It must be
                noted that Cittasya® will not be liable for any losses, caused
                to you, in relation to any unauthorised use, but you may be held
                liable for losses caused to Cittasya® by any such unauthorised
                use.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We are not responsible if information made available on this
                Platform is not accurate, complete or current. The material on
                this Platform is provided for general information only and
                should not be relied upon or used as the sole basis for making
                decisions without consulting primary, more accurate, more
                complete or more timely sources of information. We reserve the
                right, but not the obligation, to modify the contents of this
                Platform at any time. Any reliance on the material on this
                Platform is at your own risk.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  3
                </span>
                MODIFICATIONS TO THE SERVICE AND PRICES
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We reserve the right at any time to modify prices for our
                Services without any prior notice. <br />
                <br /> We reserve the right at any time to modify or discontinue
                the Service (or any part or content thereof) without notice at
                any time. <br />
                <br /> We shall not be liable to you or to any third-party for
                any modification, price change, suspension or discontinuance of
                the Service.
              </p>
              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  4
                </span>
                SERVICES
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Services shall be available exclusively online through our
                Platform, and hence shipping policy or charges are not
                applicable. <br /> <br /> We reserve the right to refuse Service
                to anyone for any reason without any prior notice.
                <br /> <br /> We reserve the right, but are not obligated, to
                limit the sales of our Services to any person, geographic region
                or jurisdiction. We may exercise this right on a case-by-case
                basis. All descriptions of Services are subject to change at any
                time without notice, at the sole discretion of us. We reserve
                the right to discontinue any Service at any time. <br /> <br />
                We do not warrant that the quality of any Services, information,
                or other material purchased or obtained by you will meet your
                expectations, or that any errors in the Service will be
                corrected.
              </p>
              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  5
                </span>
                MEDICAL ADVISORY
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                No practice or information in this app is intended to be
                professional medical advice or treatment. Please continue to
                seek the advice of your health care provider regarding any
                medical condition you may have. Do not delay seeking
                professional medical advice for any health concerns because of
                something you have practised or read here. The Company does not
                take any responsibility for the experiences users face after
                taking our Services
              </p>
              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  6
                </span>
                AGE RESTRICTION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                User must be a minimum of 18 years of age to take the Services
                of this Platform. By continued use of this Platform, you warrant
                that you are 18 years or above, and bound by this agreement. The
                Company assumes no responsibilities for liabilities for any
                claim brought by or on behalf of users being below 18 years of
                age, including, without any limitation, claims related to age
                misrepresentation.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  7
                </span>
                CANCELLATIONS AND REFUNDS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We reserve the right to refuse any order you place with us. In
                the event that we make a change to or cancel an order, we may
                attempt to notify you by contacting the e-mail, or billing
                address provided at the time the order was made.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                No refunds for any Services provided would be initiated under
                any circumstances whatsoever. All subscription plans are
                non-refundable. Please choose your plan carefully. If you stop
                using the Services provided, you will not be eligible for a
                refund, for the remainder of subscription days.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  8
                </span>
                PAYMENT AND ACCOUNT INFORMATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You agree to provide current, complete and accurate purchase and
                account information for all purchases made at the Platform. You
                agree to promptly update your account and other information,
                including your email address and payment details, so that we can
                complete your transactions and contact you as needed.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                The Company is not responsible for any fees, charges, exchange
                rates of additional charges levied by third party payment
                aggregators and other institutional banks.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                All payments made on the Platform shall be subject to all taxes,
                including but not limited to goods and services tax, duties,
                cess, or any other statutory levies, as may be prescribed under
                applicable law. The responsibility for payment of such taxes
                shall rest solely with the user, unless expressly provided
                otherwise under the Applicable Law.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  9
                </span>
                THIRD PARTY TOOLS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We may provide you with access to third-party tools (including
                payment aggregators) over which we neither monitor nor have any
                control nor input.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You acknowledge and agree that we provide access to such tools
                "as is" and "as available" without any warranties,
                representations or conditions of any kind and without any
                endorsement. We shall have no liability whatsoever arising from
                or relating to your use of third-party tools.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Any use by you of third-party tools offered through the Platform
                is entirely at your own risk and discretion and you should
                ensure that you are familiar with and approve of the terms on
                which tools are provided by the relevant third-party
                provider(s).
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We may also, in the future, offer new Services and/or features
                on our Platform through third party tools. We reserve the right
                to modify the current scope of existing third party tools or
                engage with new third party tools without any prior notice. Such
                new features and/or Services shall also be subject to these
                Terms and Conditions.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  10
                </span>
                THIRD-PARTY LINKS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Certain content, products and Services available via our Service
                may include materials from third parties.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Third-party links on this Platform may direct you to third-party
                Platforms that are not affiliated with us. We are not
                responsible for examining or evaluating the content or accuracy
                and we do not warrant and will not have any liability or
                responsibility for any third-party materials or Platforms, or
                for any other materials, products, or Services of third parties.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We are not liable for any harm or damages related to the
                purchase or use of goods, Services, resources, content, or any
                other transactions made in connection with any third-party
                Platforms. Please review carefully the third-party's policies
                and practices and make sure you understand them before you
                engage in any transaction. Complaints, claims, concerns, or
                questions regarding third-party products should be directed to
                the third-party and not us.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  11
                </span>
                USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                If you send, with or without our request, any creative ideas,
                testimonials, feedbacks, suggestions, proposals, plans, or other
                materials, whether online, by email, by postal mail, or
                otherwise (collectively, 'comments'), you agree that we may, at
                any time, without restriction, edit, copy, publish, distribute,
                translate and otherwise use in any medium any comments that you
                forward to us. We are under no obligation i) to maintain any
                comments in confidence; ii) to pay compensation for any
                comments; or iii) to respond to any comments.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We may monitor, edit or remove content that we determine in our
                sole discretion to be unlawful, offensive, threatening,
                libelous, defamatory, pornographic, obscene or otherwise
                objectionable at our sole discretion.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You agree that your comments will not violate rights of any
                third-party, including copyright, trademark, privacy,
                personality or other personal or proprietary right. You further
                agree that your comments will not contain libelous or otherwise
                unlawful, abusive or obscene material, or contain any computer
                virus or other malware that could in any way affect the
                operation of the Service or any related Platform. You shall not
                use a false e-mail address, pretend to be someone other than
                yourself, or otherwise mislead us or third-parties as to the
                origin of any comments. You are solely responsible for any
                comments you make and their accuracy. We take no responsibility
                and assume no liability for any comments posted by you or any
                third-party on our Platform.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  12
                </span>
                PERSONAL INFORMATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Your submission of personal information through the Platform is
                governed by our Privacy Policy. To view our Privacy Policy go to
                https://www.cittasya.com/privacy
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  13
                </span>
                ERRORS, INACCURACIES AND OMISSIONS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Occasionally there may be information on our Platform or in the
                Service that contains typographical errors, inaccuracies or
                omissions that may relate to Service descriptions, pricing,
                promotions and offers. We reserve the right to correct any
                errors, inaccuracies or omissions, and to change or update
                information or cancel orders if any information in the Service
                or on any related Platform is inaccurate at any time without
                prior notice (including after you have submitted your order).
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We undertake no obligation to update, amend or clarify
                information in the Service or on any related Platform, including
                without limitation, pricing information, except as required by
                law. No specified update or refresh date applied in the Service
                or on any related Platform, should be taken to indicate that all
                information in the Service or on any related Platform has been
                modified or updated.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  14
                </span>
                PROHIBITED USES
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You agree not to alter, modify, reproduce, duplicate, copy,
                sell, resell or exploit any portion of the Service, use of the
                Service, or access to the Service or any contact on the Platform
                through which the Service is provided, without express written
                permission by us.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                In addition to other prohibitions as set forth in the Terms and
                Conditions, you are prohibited from using the Platform or its
                content: (a) for any unlawful purpose; (b) to solicit others to
                perform or participate in any unlawful acts; (c) to violate any
                international, national or state regulations, rules, laws, or
                local ordinances; (d) to infringe upon or violate our
                intellectual property rights or the intellectual property rights
                of others; (e) to harass, abuse, insult, harm, defame, slander,
                disparage, intimidate, or discriminate based on gender, sexual
                orientation, religion, ethnicity, race, age, national origin, or
                disability; (f) to submit false or misleading information; (g)
                to upload or transmit viruses or any other type of malicious
                code that will or may be used in any way that will affect the
                functionality or operation of the Service or of any related
                Platform, other Platforms, or the Internet; (h) to collect or
                track the personal information of others; (i) to spam, phish,
                pharm, pretext, spider, crawl, or scrape; (j) for any obscene or
                immoral purpose; (k) to interfere with or circumvent the
                security features of the Service or any related Platform, other
                Platforms, or the Internet; or (l) to access any Information
                through any technology or means other than the audio and video
                playback pages of the Service itself, the Embeddable Player, or
                other explicitly authorized means Cittasya® may designate. We
                reserve the right to terminate your use of the Service or any
                related Platform for engaging in any of the prohibited uses.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  15
                </span>
                DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We do not guarantee, represent or warrant that your use of our
                Service will be uninterrupted, timely, secure or error-free.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We do not guarantee, represent or warrant that the results that
                may be obtained from the use of the Service will be accurate or
                reliable.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You agree that from time to time we may remove the Service for
                indefinite periods of time or cancel the Service at any time,
                without notice to you.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You expressly agree that your use of, or inability to use, the
                Service is at your sole risk. The Service (except as expressly
                stated by us) provided 'as is' and 'as available' for your use,
                without any representation, warranties or conditions of any
                kind, either express or implied.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                In no case shall the Company, its directors, officers,
                employees, affiliates, agents, contractors, interns, suppliers,
                Service providers or licensors be liable for any injury, loss,
                claim, or any direct, indirect, incidental, punitive, special,
                or consequential damages of any kind, including without
                limitation, emotional distress, physical ailment, lost profits,
                lost revenue, lost savings, loss of data, replacement costs, or
                any similar damages, whether based in contract, tort (including
                negligence), strict liability or otherwise, arising from or in
                relation to your use of any of the Service, or for any other
                claim related in any way to your use of the Service, including,
                but not limited to, any errors or omissions in any content, or
                any loss or damage of any kind incurred as a result of the use
                of the Service or any content posted, transmitted, or otherwise
                made available via the Service, even if advised of their
                possibility.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  16
                </span>
                INDEMNIFICATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You agree to indemnify, defend and hold harmless the Company and
                its subsidiaries, affiliates, partners, officers, directors,
                agents, contractors, licensors, Service providers,
                subcontractors, suppliers, interns and employees, if any,
                harmless from any claim or demand, including reasonable
                attorneys' fees, made by any third-party due to or arising out
                of your breach of these Terms and Conditions or the documents
                they incorporate by reference, or your violation of any law or
                the rights of a third-party.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  17
                </span>
                SEVERABILITY
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                In the event that any provision of these Terms and Conditions is
                determined to be unlawful, void or unenforceable, such provision
                shall nonetheless be enforceable to the fullest extent permitted
                by applicable law, and the unenforceable portion shall be deemed
                to be severed from these Terms and Conditions. Such
                determination shall not affect the validity and enforceability
                of any other remaining provisions.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  18
                </span>
                TERMINATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                The obligations and liabilities of the parties incurred prior to
                the termination date shall survive the termination of this
                agreement for all purposes.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                These Terms and Conditions are effective unless and until
                terminated by either you or us. You may terminate these Terms
                and Conditions at any time, by notifying us that you no longer
                wish to use our Service, along with the reason for doing so.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                If we suspect that you have failed, to comply with any law or
                provision of these Terms and Conditions, we have the right to
                deny you access to our Services, or any part thereof, at any
                time, without ascribing any reason and we will not be liable to
                repay you any amount, in lieu of such discontinuation.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  19
                </span>
                ENTIRE AGREEMENT
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                The failure of us to exercise or enforce any right or provision
                of these Terms and Conditions shall not constitute a waiver of
                such right or provision.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                These Terms and Conditions and any policies or operating rules
                posted by us on this Platform or in respect to the Service
                constitutes the entire agreement and understanding between the
                Company and you, and governs your use of the Service,
                superseding any prior or contemporaneous agreements,
                communications and proposals, whether oral or written, between
                you and us (including, but not limited to, any prior versions of
                the Terms and Conditions).
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Any ambiguities in the interpretation of these Terms and
                Conditions shall not be construed against the drafting party.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  20
                </span>
                GOVERNING LAW
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                These Terms and Conditions and any separate agreements whereby
                we provide you Services shall be governed by and construed in
                accordance with the laws of India.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  21
                </span>
                CHANGES TO TERMS AND CONDITIONS
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                You can review the most current version of the Terms and
                Conditions at any time at this page.
              </p>
              <p className="mb-6 text-gray-700 leading-relaxed">
                We reserve the right, at our sole discretion, to update, change
                or replace any part of these Terms and Conditions by posting
                updates and changes to our Platform. It is your responsibility
                to check our Platform periodically for changes. Your continued
                use of or access to our Platform or the Service following the
                posting of any changes to these Terms and Conditions constitutes
                acceptance of those changes.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6 flex items-center">
                <span className="bg-soft-saffron text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3">
                  22
                </span>
                CONTACT INFORMATION
              </h2>
              <p className="mb-6 text-gray-700 leading-relaxed">
                Questions about the Terms and Conditions should be sent to us at
                support@cittasya.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsContent;
